import { palette, categoryAccent } from '@repo/ui/theme';

export const CHART_CONFIG = {
  primaryColor: categoryAccent['session-performance'],
  sessionColor: categoryAccent['session-performance'],
  markersColor: categoryAccent['session-performance'],
  backgroundColor: 'var(--anl-surface)',
  textColor: 'var(--anl-text)',
  titleColor: 'var(--anl-text)',
  gridColor: palette.surfaceElev,
  borderColor: 'var(--anl-border)',
};

export const ZOOM_CONFIG = {
  bufferBeforeMinutes: 5,
  bufferAfterMinutes: 3,
  minTotalDurationMinutes: 15,
  minZoomDurationMinutes: 60,
};
